import React from "react";
import PropTypes from "prop-types";
import P from "../../Typography/P";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "../../Radio";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "../../FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import dictionary from "../../../../dictionary";

import styles from "../radio-group.module.scss";

function Icon(props) {
  const {onChange, name, current, content} = props;
  return (
    <div className={styles.root}>
      <FormControl component="fieldset" className={styles.fieldset}>
        <FormLabel component="legend">
          <P size="small" className={styles.legend}>
            Доступные материалы
          </P>
        </FormLabel>
        <RadioGroup
          defaultValue={current}
          value={current}
          aria-label={name}
          className={styles.group}
          onChange={(event) => onChange(name, event.target.value)}
        >
          {content.map(({value, label, disabled}) => (
            <Tooltip key={`${name}-${value}`} title={dictionary.item[value]}>
              <FormControlLabel
                className={styles.radio}
                key={value}
                value={value}
                control={
                  <Radio disabled={disabled} checked={current === value} />
                }
                label={
                  <span
                    className={styles.labelImage}
                    style={{backgroundImage: `url(${label})`}}
                  />
                }
              />
            </Tooltip>
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
}

Icon.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default Icon;
